import { EntityType, LanguageType } from '@/__generated__/gateway/graphql';

import { getLanguageType } from './helpers';

/**
 * Parses `window.Shopify.locale` to a `LanguageType`, with a fallback to `LanguageType.En`.
 */
export const getLanguageFromContext = () =>
  getLanguageType(window.Shopify.locale, LanguageType.En);

/**
 * Returns Product or Pattern according to `window.Hobbii.productPage`.
 */
export const getEntityIdFromContext = () => {
  return window.Hobbii?.productPage?.productGroupId?.toString();

  // TODO: also return window.Hobbii?.competitionPage?.competitionId?.toString(); once implemented
};

/**
 * Returns Product or Pattern according to `window.Hobbii.productPage`.
 */
export const getEntityFromContext = () => {
  if (window.Hobbii?.productPage?.productGroupId) {
    return window.Hobbii?.productPage?.isPattern
      ? EntityType.Pattern
      : EntityType.Product;
  }

  // TODO: return EntityType.Competition when implemented, and has a competition id?
};
